import tinycolor from 'tinycolor2';
import { find, filter, includes, forEach, orderBy, uniqBy } from 'lodash';
import features from 'lib/common/features';

/**
 * Goes through each price and generates a random color for each given property.
 * If multiple zones have same price point then same color is assigned to those
 * zones unless its a box price in which they will be treated as separate price.
 *
 * @param  Array prices
 * @return Array
 */
export function prepareColorCode(prices, additionalPrices, customColors) {
  if (!features.isEnabled('seatColours')) {
    return [];
  }

  let allPrices = [].concat(prices, additionalPrices);

  let uniqPrices = uniqBy(allPrices, price => price.zone_group_no).map(price => price.zone_group_no);

  let foundPrices = [];
  let colors = [];

  let color;
  let hColor = 359 / uniqPrices.length;
  let sColor = 35 / uniqPrices.length;
  let vColor = 15 / uniqPrices.length;

  forEach(allPrices, price => {
    if (customColors) {
      color = find(customColors, c => {
        return parseInt(price.zone_group_no, 10) === parseInt(c.zoneGroup, 10);
      });

      if (color) {
        color = color.color

        colors.push({
          zone_group_no: parseInt(color.zoneGroup, 10),
          color: color,
        })
      }
    } else {
      if (!includes(foundPrices, price.zone_group_no)) {
        color = tinycolor({
          h: hColor * foundPrices.length,
          s: 65 + sColor,
          v: 75 + vColor,
        }).toHexString();

        foundPrices.push(price.zone_group_no);
      } else {
        color = find(colors, x => {
          return parseInt(price.zone_group_no, 10) === parseInt(x.zone_group_no, 10);
        }).color;
      }
    }

    colors.push({
      zone_group_no: parseInt(price.zone_group_no, 10),
      color: color,
    })
  });

  return colors;
}

/**
 * Fetches a color for a particular price zone.
 *
 * @param  int    zone
 * @param  Array  colors
 * @return string
 */
export function getColorCode(data, colors) {
  let color = find(colors, x => {
    return parseInt(data.zone_group_no, 10) === parseInt(x.zone_group_no, 10);
  });

  if (!color) {
    return null;
  }

  return color.color;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/colorCode.js